export enum NomenclatureTypeFieldType {
    characteristic = 1,
    parameter = 2,
    group = 3,
}
